if (!customElements.get("product-info")) {
    customElements.define(
        "product-info",
        class ProductInfo extends HTMLElement {
            onVariantChangeUnsubscriber = undefined;
            preProcessHtmlCallbacks = [];

            constructor() {
                super();

                // this.quantityInput = this.querySelector(".quantity__input");
                this.querySelector(".js-addtocart-btn").addEventListener(
                    "click",
                    () => this.addTocartMessage(this.dataset.title)
                );
            }

            connectedCallback() {
                this.onVariantChangeUnsubscriber = subscribe(
                    PUB_SUB_EVENTS.optionValueSelectionChange,
                    this.handleOptionValueChange.bind(this)
                );
                const selectedValues = Array.from(
                    document.querySelectorAll("select")
                )
                    .map((select) => select.value)
                    .join(" / ");
                console.log(typeof selectedValues);
                // let selectedOptionValues = this.querySelector("select").value;
                let currentDataVariantname = this.querySelectorAll(
                    "[data-variant-name]"
                );
                if (!currentDataVariantname.length) return;
                currentDataVariantname.forEach((element) => {
                    if (
                        element.getAttribute("data-variant-name").toLowerCase() ===
                        selectedValues.toLowerCase()
                    ) {
                        element.classList.remove("hidden");
                    } else {
                        element.classList.add("hidden");
                    }
                });
            }

            handleOptionValueChange({
                data: { event, target, selectedOptionValues },
            }) {
                console.log(selectedOptionValues);

                const productUrl = this.dataset.url;

                this.renderProductInfo({
                    requestUrl: this.buildRequestUrlWithParams(
                        productUrl,
                        selectedOptionValues
                    ),
                    targetId: target.id,
                    callback: this.handleUpdateProductInfo(productUrl),
                });
            }

            renderProductInfo({ requestUrl, targetId, callback }) {
                this.querySelector(".js-product-overlay").classList.remove(
                    "hidden"
                );
                fetch(requestUrl)
                    .then((response) => response.text())
                    .then((responseText) => {
                        const html = new DOMParser().parseFromString(
                            responseText,
                            "text/html"
                        );
                        callback(html);
                    })
                    .then(() => {
                        // set focus to last clicked option value
                        document.querySelector(`#${targetId}`)?.focus();
                    })
                    .catch((error) => {
                        if (error.name === "AbortError") {
                            console.log("Fetch aborted by user");
                        } else {
                            console.error(error);
                        }
                    })
                    .finally(() => {
                        this.querySelector(".js-product-overlay").classList.add(
                            "hidden"
                        );
                    });
            }

            getSelectedVariant(productInfoNode) {
                const selectedVariant = productInfoNode.querySelector(
                    "variant-selects [data-selected-variant]"
                )?.innerHTML;
                return !!selectedVariant ? JSON.parse(selectedVariant) : null;
            }

            buildRequestUrlWithParams(url, optionValues) {
                const params = [];

                params.push(`section_id=${this.sectionId}`);

                if (optionValues.length) {
                    params.push(`option_values=${optionValues.join(",")}`);
                }

                return `${url}?${params.join("&")}`;
            }

            // updateOptionValues(html) {
            //     const variantSelects = html.querySelector("variant-selects");
            //     if (variantSelects) {
            //         HTMLUpdateUtility.viewTransition(
            //             this.variantSelectors,
            //             variantSelects,
            //             this.preProcessHtmlCallbacks
            //         );
            //     }
            // }

            handleUpdateProductInfo(productUrl) {
                return (html) => {
                    const variant = this.getSelectedVariant(html);
                    console.log("variant", variant);

                    // this.pickupAvailability?.update(variant);
                    // this.updateOptionValues(html);
                    this.updateURL(productUrl, variant?.id);
                    this.updateVariantInputs(variant?.id);

                    // if (!variant) {
                    //     this.setUnavailable();
                    //     return;
                    // }

                    this.updateMedia(html, variant?.featured_media?.id);

                    const updateSourceFromDestination = (
                        id,
                        shouldHide = (source) => false
                    ) => {
                        const source = html.getElementById(
                            `${id}-${this.sectionId}`
                        );
                        const destination = this.querySelector(
                            `#${id}-${this.dataset.section}`
                        );
                        if (source && destination) {
                            destination.innerHTML = source.innerHTML;
                            destination.classList.toggle(
                                "hidden",
                                shouldHide(source)
                            );
                        }
                    };

                    updateSourceFromDestination("price");
                    // updateSourceFromDestination("more-details");
                    this.showVariantMoreDetils(variant?.title);

                    // Trigger a custom event after updating the media
                    // const event = new CustomEvent("variantChanged", {
                    //     detail: {
                    //         variantId: variant?.id,
                    //         variantFeaturedMediaId: variant?.featured_media?.id,
                    //     },
                    // });
                    // document.dispatchEvent(event);

                    // updateSourceFromDestination("Sku", ({ classList }) =>
                    //     classList.contains("hidden")
                    // );
                    // updateSourceFromDestination(
                    //     "Inventory",
                    //     ({ innerText }) => innerText === ""
                    // );
                    // updateSourceFromDestination("Volume");
                    // updateSourceFromDestination(
                    //     "Price-Per-Item",
                    //     ({ classList }) => classList.contains("hidden")
                    // );

                    // this.updateQuantityRules(this.sectionId, html);
                    // this.querySelector(
                    //     `#Quantity-Rules-${this.dataset.section}`
                    // )?.classList.remove("hidden");
                    // this.querySelector(
                    //     `#Volume-Note-${this.dataset.section}`
                    // )?.classList.remove("hidden");

                    // this.productForm?.toggleSubmitButton(
                    //     html
                    //         .getElementById(
                    //             `ProductSubmitButton-${this.sectionId}`
                    //         )
                    //         ?.hasAttribute("disabled") ?? true,
                    //     window.variantStrings.soldOut
                    // );

                    // publish(PUB_SUB_EVENTS.variantChange, {
                    //     data: {
                    //         sectionId: this.sectionId,
                    //         html,
                    //         variant,
                    //     },
                    // });
                };
            }

            showVariantMoreDetils(selectedVariantName) {
                let currentDataVariantname = this.querySelectorAll(
                    "[data-variant-name]"
                );
                // if (!currentDataVariantname.length) return;
                // this.querySelectorAll("[data-variant-name]").forEach(
                //     (element) => {
                //         element.classList.add("hidden");
                //     }
                // );
                // this.querySelector(
                //     `[data-variant-name="${selectedVariantName}"]`
                // ).classList.remove("hidden");
                if (!currentDataVariantname.length) return;
                currentDataVariantname.forEach((element) => {
                    if (
                        element.getAttribute("data-variant-name").toLowerCase() ===
                        selectedVariantName.toLowerCase()
                    ) {
                        element.classList.remove("hidden");
                    } else {
                        element.classList.add("hidden");
                    }
                });
            }

            updateVariantInputs(variantId) {
                this.querySelectorAll(
                    `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
                ).forEach((productForm) => {
                    const input = productForm.querySelector('input[name="id"]');
                    input.value = variantId ?? "";
                    input.dispatchEvent(new Event("change", { bubbles: true }));
                });
            }

            updateURL(url, variantId) {
                if (this.dataset.updateUrl === "false") return;
                window.history.replaceState(
                    {},
                    "",
                    `${url}${variantId ? `?variant=${variantId}` : ""}`
                );
            }

            updateMedia(html, variantFeaturedMediaId) {
                console.log("updateMedia", variantFeaturedMediaId);
                if (!variantFeaturedMediaId) return;

                const destMediaGalleryViewr =
                    document.querySelector(".js-gallery-viewer");
                const sourceMediaGalleryViewr =
                    html.querySelector(".js-gallery-viewer");

                const destMediaGalleryThumbnail = document.querySelector(
                    ".js-gallery-thumbnails"
                );
                const sourceMediaGalleryThumbnail = html.querySelector(
                    ".js-gallery-thumbnails"
                );
                const activeThumbnail =
                    sourceMediaGalleryThumbnail.querySelector("div.active")
                        .dataset.target;
                if (activeThumbnail) {
                    destMediaGalleryThumbnail
                        .querySelectorAll("[data-target]")
                        .forEach((element) => {
                            element.classList.remove("active");
                        });
                    destMediaGalleryThumbnail
                        .querySelector(`[data-target="${activeThumbnail}"]`)
                        .classList.add("active");
                }
                destMediaGalleryViewr.innerHTML =
                    sourceMediaGalleryViewr.innerHTML;

                // const mediaGallerySource =
                //     this.querySelector(".product-main-img");
                // const mediaGalleryDestination =
                //     html.querySelector(`.product-main-img`);

                // if (mediaGallerySource && mediaGalleryDestination) {
                //     this.querySelector(".product-main-img").innerHTML =
                //         html.querySelector(".product-main-img").innerHTML;
                //     this.querySelector(".product-thumb-img").innerHTML =
                //         html.querySelector(".product-thumb-img").innerHTML;
                // }
                // setTimeout(() => {
                //     this.querySelectorAll(".thumbnail-images").forEach(
                //         (elm) => {
                //             elm.classList.remove("swiper-slide-thumb-active");
                //         }
                //     );
                //     this.querySelector(
                //         `[data-media-thumb-id="${variantFeaturedMediaId}"]`
                //     ).classList.add("swiper-slide-thumb-active");
                // }, 1000);
            }

            get variantSelectors() {
                return this.querySelector("variant-selects");
            }

            get sectionId() {
                return this.dataset.section;
            }

            addTocartMessage(title) {
                sessionStorage.setItem("cartAddTitle", title);
            }
        }
    );
}
